import React from 'react';
import { useAlert, AlertType } from '../../contexts/AlertContext';
import './Alert.css';

const Alert: React.FC = () => {
    const { alerts, clearAlert } = useAlert();

    if (alerts.length === 0) return null;

    return (
        <div className="alert-container">
            {alerts.map(alert => (
                <div
                    key={alert.id}
                    className={`alert alert-${alert.type}`}
                    onClick={() => clearAlert(alert.id)}
                >
                    <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                    {alert.persistent && (
                        <button
                            className="alert-close-btn"
                            onClick={(e) => { e.stopPropagation(); clearAlert(alert.id); }}
                            aria-label="Dismiss"
                        >
                            &times;
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Alert;